import React from 'react';

const Loading = ({error = false}) => {
  return (
    <div className="bg-black h-screen w-screen flex items-center justify-center">
      {error ? (
        <i className="fa-fw fas fa-exclamation-triangle text-gray-800 text-4xl"/>
      ) : (
        <i className="fa-fw fas fa-circle text-gray-800 text-2xl"/>
      )}
    </div>
  )
};

export default Loading;
